import { Text } from "@mdotm/shadcn/legacy/components";
import type { InvestmentSummary } from "@eu.mdotm.api/sphere";
import { useTranslation } from "react-i18next";
import { formatCurrencyAmount } from "$root/utils/currency";

export type PortfolioModeAndAumProps = Pick<InvestmentSummary, "quantityMode" | "aum" | "baseCurrency">;

/** The portfolio's mode, and for a quantities portfolio its AUM — which is left out, not dashed, when absent. */
export function PortfolioModeAndAum(props: PortfolioModeAndAumProps): React.JSX.Element {
	const { quantityMode, aum, baseCurrency } = props;
	const { t } = useTranslation();

	return (
		<>
			<div>
				<Text type="Body/M/Book">{t("PORTFOLIOS.MODE")}</Text>
				&nbsp;
				<Text type="Body/M/Bold">{quantityMode ? t("PORTFOLIOS.MODE_QUANTITIES") : t("PORTFOLIOS.MODE_WEIGHTS")}</Text>
			</div>
			{quantityMode && aum != null && (
				<div>
					<Text type="Body/M/Book">{t("PORTFOLIOS.AUM")}</Text>
					&nbsp;
					<Text type="Body/M/Bold">{formatCurrencyAmount(aum, baseCurrency, 0)}</Text>
				</div>
			)}
		</>
	);
}
